export const NS = 'example'

const getName = (name: string) => `${NS}:${name}`

export default {
  first_url: {
    name: getName('first_url.name')
  }
}
